import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import consoleLogMobile from 'consoleLogMobile';
import { RecoilRoot } from 'recoil';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  //<React.StrictMode>
  <RecoilRoot>
    <App />
  </RecoilRoot>
  //</React.StrictMode>
);
reportWebVitals();
consoleLogMobile();
